import { useMemo } from 'react';
import dayjs from 'dayjs';

export function ToManifestDate(props: { date: string }) {
  const d = useMemo(() => {
    const date = ToManifestDateObj(props.date);
    return date?.format('dddd DD MMMM YYYY');
  }, [props.date]);
  return <>{d}</>;
}

export function ToManifestDateObj(date: string) {
  if (!date || date.indexOf('-') == date.lastIndexOf('-')) {
    return null;
  }
  const y = Number(date.split('-')[2]);
  const m = Number(date.split('-')[1]);
  const d = Number(date.split('-')[0]);
  return dayjs()
    .year(y)
    .month(m - 1)
    .date(d)
    .hour(0)
    .minute(0)
    .millisecond(0);
}
